<div class="copy-container" [class.small]="small">

  @if (!showSuccess) {
    <button class="copy-btn" (click)="copyToClipboard()">
      <img src="assets/icons/attachment-copy-link.svg" alt="copy" #edit [isTitle]="true"
        fiTranslation="ALT_TEXT_REQUEST_DETAIL_COPY_ID" matTooltip="{{edit.dataset.matTooltip}}"
        matTooltipPosition="below" matTooltipClass='tooltip-style'>
    </button>
  }

  @if (showSuccess) {
    <div class="success-text">
      <img src="assets/icons/check-green-filled.svg" alt="checkmark">
      <span fiTranslation="ALT_TEXT_REQUEST_DETAIL_COPY_SUCCESS"></span>
    </div>
  }
</div>
